const getCookieValueByKey = (cookie, key) => {
  const indexableKeys = ['path', 'domain', 'expires'];
  const validKeys = ['name', 'value', ...indexableKeys];

  const isValidKey = validKeys.some(vKey => vKey === key);
  const isIndexableKey = indexableKeys.some(iKey => iKey === key);

  const cleanCookie = cookie && cookie.split(' ').join('');

  if (!cookie || !isValidKey) {
    return '';
  }

  if (key === 'name' || key === 'value') {
    const indexKey = (key === 'name') ? 0 : 1;

    return (!isIndexableKey)
      ? cleanCookie.split('=')[indexKey]
      : '';
  }

  return cleanCookie.split(`${key}=`)[1]
    ? cleanCookie.split(`${key}=`)[1].split(';')[0]
    : '';
};

export default class Cookie {
  name = '';
  value = '';
  path = '/';
  domain = process.env.APP_DOMAIN;
  secure = false;
  expires = '';
  cookie = '';
  sameSite = 'Strict';

  constructor(cookie) {
    this.name = cookie.name ? cookie.name : this.name;
    this.value = cookie.value ? cookie.value : this.value;
    this.path = cookie.path ? cookie.path : this.path;
    this.domain = cookie.domain ? cookie.domain : this.domain;
    this.secure = cookie.secure ? cookie.secure : this.secure;
    this.expires = cookie.expires ? cookie.expires : this.expires;
    this.sameSite = cookie.sameSite ? cookie.sameSite : this.sameSite;

    this.updateCookie(this.getSession());

    return this.buildCookie();
  }

  treatCookie(cookie) {
    const name = getCookieValueByKey(cookie, 'name');
    const value = getCookieValueByKey(cookie, 'value');
    const path = getCookieValueByKey(cookie, 'path');
    const domain = getCookieValueByKey(cookie, 'domain');
    const expires = getCookieValueByKey(cookie, 'expires');
    const samesite = getCookieValueByKey(cookie, 'samesite');

    const treatedCookie = {
      ...name && { name },
      ...value && { value },
      ...path && { path },
      ...domain && { domain },
      ...expires && { expires },
      ...samesite && { samesite },
    };

    return treatedCookie;
  }

  buildCookie() {
    const cookiePath = this.path ? `path=${this.path};` : '';
    const cookieDomain = this.domain ? `domain=${this.domain};` : '';
    const cookieExpires = this.expires ? `expires=${this.expires};` : '';
    const cookieSecure = this.secure ? 'secure;' : '';
    const cookieSameSite = this.sameSite ? `SameSite=${this.sameSite}` : '';

    this.cookie = `${this.name}=${this.value};${cookiePath}${cookieDomain}${cookieExpires}${cookieSecure}${cookieSameSite}`;

    return this;
  }

  updateCookie(cookie) {
    cookie.value && this.updateValue(cookie.value);
    cookie.path && this.updatePath(cookie.path);
    cookie.domain && this.updateDomain(cookie.domain);
    cookie.expires && this.updateExpires(cookie.expires);

    return this;
  }

  updateValue(value) {
    this.value = value;
    this.updateExpires('');
    this.buildCookie();

    return this;
  }

  updatePath(path) {
    this.path = path;
    this.updateExpires('');
    this.buildCookie();

    return this;
  }

  updateDomain(domain) {
    this.domain = domain;
    this.updateExpires('');
    this.buildCookie();

    return this;
  }

  updateExpires(expires) {
    this.expires = expires;
    this.buildCookie();

    return this;
  }

  setSession() {
    document.cookie = this.cookie;

    return this;
  }

  getSession() {
    const cookie = document.cookie.split(';').find(docCookie => {
      return this.treatCookie(docCookie).name === this.name;
    });

    return this.treatCookie(cookie);
  }

  deleteSession() {
    this.updateExpires('Thu, 01 Jan 1970 00:00:01 GMT');

    this.buildCookie();
    this.setSession();

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/cookie.js